/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateGroupVisitSchema } from '../models/CreateGroupVisitSchema';
import type { GroupVisitDetailSchema } from '../models/GroupVisitDetailSchema';
import type { PagedGroupVisitListSchema } from '../models/PagedGroupVisitListSchema';
import type { RecurringGroupVisitDeleteStrategyChoices } from '../models/RecurringGroupVisitDeleteStrategyChoices';
import type { UpdateGroupVisitSchema } from '../models/UpdateGroupVisitSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GroupVisitsApi {
    /**
     * Add Patient To Group Visit
     * Add patient to group visit. <br>Required Permission: create_visit
     * @returns GroupVisitDetailSchema Created
     * @throws ApiError
     */
    public static groupVisitsAddPatientToGroupVisitPost({
        groupVisitId,
        patientId,
    }: {
        groupVisitId: string,
        patientId: string,
    }): CancelablePromise<GroupVisitDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/group/{group_visit_id}/patient/{patient_id}/',
            path: {
                'group_visit_id': groupVisitId,
                'patient_id': patientId,
            },
        });
    }
    /**
     * Remove Patient From Group Visit
     * Remove patient from group visit. <br>Required Permission: delete_visit
     * @returns GroupVisitDetailSchema OK
     * @throws ApiError
     */
    public static groupVisitsRemovePatientFromGroupVisitDelete({
        groupVisitId,
        patientId,
        sendNotificationToSubstitutes = false,
    }: {
        groupVisitId: string,
        patientId: string,
        sendNotificationToSubstitutes?: boolean,
    }): CancelablePromise<GroupVisitDetailSchema> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/group/{group_visit_id}/patient/{patient_id}/',
            path: {
                'group_visit_id': groupVisitId,
                'patient_id': patientId,
            },
            query: {
                'send_notification_to_substitutes': sendNotificationToSubstitutes,
            },
        });
    }
    /**
     * Add Substitute To Group Visit
     * Add substitute to group visit. <br>Required Permission: create_visit
     * @returns GroupVisitDetailSchema Created
     * @throws ApiError
     */
    public static groupVisitsAddSubstituteToGroupVisitPost({
        groupVisitId,
        patientId,
    }: {
        groupVisitId: string,
        patientId: string,
    }): CancelablePromise<GroupVisitDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/group/{group_visit_id}/substitute/{patient_id}/',
            path: {
                'group_visit_id': groupVisitId,
                'patient_id': patientId,
            },
        });
    }
    /**
     * Remove Substitute From Group Visit
     * Remove substitute from group visit. <br>Required Permission: delete_visit
     * @returns GroupVisitDetailSchema OK
     * @throws ApiError
     */
    public static groupVisitsRemoveSubstituteFromGroupVisitDelete({
        groupVisitId,
        patientId,
    }: {
        groupVisitId: string,
        patientId: string,
    }): CancelablePromise<GroupVisitDetailSchema> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/group/{group_visit_id}/substitute/{patient_id}/',
            path: {
                'group_visit_id': groupVisitId,
                'patient_id': patientId,
            },
        });
    }
    /**
     * Create Group Visit
     * Create group visit. <br>Required Permission: create_group_visit
     * @returns GroupVisitDetailSchema Created
     * @throws ApiError
     */
    public static groupVisitsCreateGroupVisitPost({
        requestBody,
    }: {
        requestBody: CreateGroupVisitSchema,
    }): CancelablePromise<GroupVisitDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/group/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Group Visit List
     * Get list of group visits, each with its members. <br>Required Permission: get_group_visit_detail
     * @returns PagedGroupVisitListSchema OK
     * @throws ApiError
     */
    public static groupVisitsGetGroupVisitListGet({
        userIds,
        startDate,
        endDate,
        limit = 100,
        offset,
    }: {
        userIds?: (Array<string> | null),
        startDate?: (string | null),
        endDate?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedGroupVisitListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/group/',
            query: {
                'user_ids': userIds,
                'start_date': startDate,
                'end_date': endDate,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Delete Group Visit
     * Delete group visit. <br>Required Permission: delete_group_visit
     * @returns void
     * @throws ApiError
     */
    public static groupVisitsDeleteGroupVisitDelete({
        groupVisitId,
        recurringDeleteStrategy,
    }: {
        groupVisitId: string,
        recurringDeleteStrategy?: (RecurringGroupVisitDeleteStrategyChoices | null),
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/group/{group_visit_id}/',
            path: {
                'group_visit_id': groupVisitId,
            },
            query: {
                'recurring_delete_strategy': recurringDeleteStrategy,
            },
        });
    }
    /**
     * Detail Group Visit
     * Get group visit. <br>Required Permission: get_group_visit_detail
     * @returns GroupVisitDetailSchema OK
     * @throws ApiError
     */
    public static groupVisitsDetailGroupVisitGet({
        groupVisitId,
    }: {
        groupVisitId: string,
    }): CancelablePromise<GroupVisitDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/group/{group_visit_id}/',
            path: {
                'group_visit_id': groupVisitId,
            },
        });
    }
    /**
     * Update Group Visit
     * Update group visit. <br>Required Permission: update_group_visit
     * @returns GroupVisitDetailSchema OK
     * @throws ApiError
     */
    public static groupVisitsUpdateGroupVisitPatch({
        groupVisitId,
        requestBody,
    }: {
        groupVisitId: string,
        requestBody: UpdateGroupVisitSchema,
    }): CancelablePromise<GroupVisitDetailSchema> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/group/{group_visit_id}/',
            path: {
                'group_visit_id': groupVisitId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
